module.exports = __webpack_public_path__ + "static/media/ifsc.800cb131.png";